import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Icon = styled.img`
  display: block;
  width: 80px;
  height: 80px;
  color: green;
`;

export const Text = styled.h2`
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.success};
  display: block;
  margin-top: 15px;
  font-size: 18px;
`;
